import { mapLink, siteLine, type SitePlace, type ViewerRole } from '@nsb/core';

/**
 * The site under a project's title on NSB's home (P-35, Jason on Kalley's header: "this should be resolved to a real
 * address, be title case, and have a map icon jump link to its location"): the address as picked, else as typed in
 * title case (core `siteLine`), with NSB's link to it on Google Maps (core `mapLink`). A client never sees the street,
 * so never this: their copy of a project carries no site, and this gives them nothing even if it did.
 */
export function headerSite(p: { siteAddress: string | null; sitePlace: SitePlace | null; viewerRole: ViewerRole }): { words: string | null; map: string | null } {
  if (p.viewerRole === 'client') return { words: null, map: null };
  return { words: siteLine(p), map: mapLink(p) };
}
